export const CampaignActionTypes = {
    CREATE_CAMPAIGN: 'CREATE_CAMPAIGN',
    CREATE_CAMPAGIN_SUCCESS: 'CREATE_CAMPAGIN_SUCCESS',
    LOAD_CAMPAIGNS: 'LOAD_CAMPAIGNS',
    LOAD_CAMPAIGNS_SUCCESS: 'LOAD_CAMPAIGNS_SUCCESS',
    LOAD_CAMPAIGN_SALES: 'LOAD_CAMPAIGN_SALES',
    LOAD_CAMPAIGN_SALES_SUCCESS : 'LOAD_CAMPAIGN_SALES_SUCCESS',
}